<template>
  <div class="min-h-100  w-100 d-flex flex-column">
    <div class="atm-dekstop-max-width bg-plain pb-4 main h-100 w-100">
      <b-skeleton-wrapper :loading="loading">
        <template #loading>
          <child-home-data-skeleton :theme="theme"></child-home-data-skeleton>
        </template>
        <child-home-data-component
          :class="theme"
          :userName="sessionStore.userName"
          :levelInfo="levelInfo"
          :coinsInfo="coinsInfo"
          :childInfo="childInfo"
        />
        <div class="mainComponents mx-auto">
          <div style="margin-top: -59px;">
            <home-main-actions :action="mainActions" :coinsInfo="coinsInfo" />
          </div>
          <home-main-tasks :tasks="tasksToBeDisplayed" :haveTask="todayTasks.length > 0" />
          <home-second-actions :action="secondActions" />
        </div>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import { getChildData } from '@/auth';
import { getRankingAndLevelInformation, getCoinsInformation } from '@/gamification';
import { fetchTodayTasks } from '@/tasks';
import { useSessionStore } from '@/common';
import { getThemeColor } from '@/common/utils';

import { HomeMainActions, HomeMainTasks, HomeSecondActions } from '@/common/components/home';
import ChildHomeDataComponent from './ChildHomeData.vue';
import ChildHomeDataSkeleton from '@/common/components/child/skeletons/ChildHomeDataSkeleton';

export default {
  name: 'ChildMain',
  components: {
    ChildHomeDataComponent,
    HomeMainActions,
    HomeMainTasks,
    HomeSecondActions,
    ChildHomeDataSkeleton,
  },
  data: function() {
    const sessionStore = useSessionStore();
    return {
      loading: true,
      sessionStore,
      todayTasks: [],
      levelInfo: {
        image: null,
        name: '',
        childPoints: 0,
      },
      coinsInfo: {},
      childInfo: {},
      mainActions: [
        {
          title: 'New task',
          img: require('@/assets/icons/icon-task.svg'),
          class: 'newTask font-weight-bold',
          router: 'new-task',
          enable: true,
        },
        {
          title: 'My checklist',
          img: require('@/assets/icons/icon-checklist.svg'),
          class: 'checklistText text-blue-dark font-weight-bold',
          router: 'checklist',
          enable: true,
        },
      ],
      secondActions: [
        {
          title: 'Progress',
          img: require('@/assets/icons/icon-progress.svg'),
          router: '/progress',
          text: 'insights',
          enable: true,
        },
        {
          title: 'Rewards',
          img: require('@/assets/icons/icon-gift.svg'),
          router: '/rewards',
          text: 'card_giftcard',
          enable: true,
        },
        {
          title: 'Learn skills',
          img: require('@/assets/icons/icon-learn.svg'),
          router: '/learn-skills',
          text: 'school',
          enable: true,
        },
      ],
    };
  },
  computed: {
    theme() {
      return `bg-${getThemeColor(this.sessionStore.themeSelection)}`;
    },
    tasksToBeDisplayed() {
      return this.todayTasks.slice(0, 5);
    },
  },
  async mounted() {
    this.loading = true;
    let childId = this.sessionStore.userId;
    let requestsData = await Promise.all([
      fetchTodayTasks(childId),
      getRankingAndLevelInformation(childId),
      getCoinsInformation(childId),
      getChildData(childId),
    ]);
    this.todayTasks = requestsData[0];
    let levelResponse = requestsData[1];
    if (levelResponse.userLevel) {
      this.levelInfo = {
        image: levelResponse.userLevel.photo,
        name: levelResponse.userLevel.name,
        childPoints: levelResponse.userPoints,
      };
    }
    let coinsResponse = requestsData[2];
    this.coinsInfo = {
      banked: coinsResponse.Banked,
      Pending: coinsResponse.Pending,
    };
    this.childInfo = requestsData[3];
    this.loading = false;
  },
};
</script>

<style lang="scss">
.mainComponents {
  width: 95%;
  max-width: 1000px;
  padding: 0 2rem;
  margin: 0;
}

.newTask {
  color: #ff7648;
}

.checklistText {
  color: #8f98ff;
}
</style>
